import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=315734ae&"
import script from "./confirmDialog.vue?vue&type=script&lang=ts&"
export * from "./confirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports